const { isArray } = Array;

const typeOfTest = type => thing => typeof thing === type;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
    const typeLower = type.toLowerCase();
    return (thing) => kindOf(thing) === typeLower
}

function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
        return;
    }

    let i = 0;
    let size = 0;
    let value=[];

    // Force an array if not already something iterable
    if (typeof obj !== 'object') {
        /*eslint no-param-reassign:0*/
        value = [obj];
    }

    if (isArray(value)) {
        // Iterate over array values
        for (i = 0, size = value.length; i < size; i++) {
            fn(...[value[i], i, value]);
        }
    } else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(value) : Object.keys(obj);
        const len = keys.length;

        for (i = 0; i < len; i++) {
            const key = keys[i];
            fn(...[value[key], key, value]);
        }
    }
}

const normalizeHeaderName = (headers, normalizedName) => {
    forEach(headers, (value, name) => {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
}

const isUndefined = typeOfTest('undefined');

const isFunction = typeOfTest('function');

const isFormData = (thing) => {
    const pattern = '[object FormData]';
    return thing && (
        (typeof FormData === 'function' && thing instanceof FormData) ||
        toString.call(thing) === pattern ||
        (isFunction(thing.toString) && thing.toString() === pattern)
    );
}
const isArrayBuffer = kindOfTest('ArrayBuffer');

function isArrayBufferView(val) {
    // eslint-disable-next-line no-unused-vars, no-redeclare
    /*global isArrayBufferView, ArrayBuffer*/
    let result = false;
    if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
        result = ArrayBuffer.isView(val);
    } else {
        result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
    }

    return result;
}

function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
        && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

const isURLSearchParams = kindOfTest('URLSearchParams');

const isObject = (thing) => thing !== null && typeof thing === 'object';

const isStream = (val) => isObject(val) && isFunction(val.pipe);

const isFile = kindOfTest('File');

const isBlob = kindOfTest('Blob');

const axiosUtils = {
    normalizeHeaderName,
    isArray,
    typeOfTest,
    isBuffer,
    kindOf,
    kindOfTest,
    isUndefined,
    forEach,
    isFormData,
    isArrayBuffer,
    isArrayBufferView,
    isURLSearchParams,
    isStream,
    isObject,
    isFile,
    isBlob
}

export default axiosUtils;